var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('onboarding-layout',{attrs:{"title":_vm.$t('pages.identity.title'),"loading":_vm.loading,"error-text":_vm.errorText,"loading-title":_vm.$t('global.loadingMessage.verifying'),"step-title":"Verify Identity"}})}
var staticRenderFns = []

export { render, staticRenderFns }